import { Plus, Trash2, Package } from "lucide-react";
import { Input } from "@/components/ui/input";

const KOLI_TIPLERI = ["Küçük koli", "Orta koli", "Büyük koli", "Palet", "Çuval"];

export const KoliEditor = ({ kalemler, miktar, koliler, setKoliler }) => {
  const dagitilan = (i) => koliler.reduce((s, k) => s + Number(k.kalemler[i] || 0), 0);
  const set = (ki, fn) => setKoliler(koliler.map((k, j) => (j === ki ? fn(k) : k)));
  const ekle = () => {
    const kalan = Object.fromEntries(kalemler.map((k) => [k.i, Math.max(0, +(Number(miktar[k.i] || 0) - dagitilan(k.i)).toFixed(4))]));
    setKoliler([...koliler, { tip: KOLI_TIPLERI[1], kalemler: koliler.length ? {} : kalan }]);
  };
  return (
    <div className="rounded-xl border border-white/10 p-3 space-y-3" data-testid="koli-editor">
      <div className="flex items-center justify-between"><div className="text-sm font-medium flex items-center gap-2"><Package className="w-4 h-4" />Koliler <span className="text-xs text-muted-foreground font-normal">(bir koliye birden fazla ürün girebilir)</span></div>
        <button type="button" onClick={ekle} data-testid="koli-ekle" className="inline-flex items-center gap-1 text-xs text-[var(--g1)] hover:text-white"><Plus className="w-3.5 h-3.5" />Koli ekle</button></div>
      <datalist id="koli-tipleri">{KOLI_TIPLERI.map((t) => <option key={t} value={t} />)}</datalist>
      {koliler.map((k, ki) => (
        <div key={ki} className="rounded-lg bg-white/[0.04] p-3 space-y-2" data-testid={`koli-${ki}`}>
          <div className="flex items-center gap-2"><span className="font-mono text-xs w-14">Koli {ki + 1}</span>
            <Input list="koli-tipleri" data-testid={`koli-tip-${ki}`} className="bg-white/5 h-8 text-xs" value={k.tip} onChange={(e) => set(ki, (x) => ({ ...x, tip: e.target.value }))} />
            <button type="button" data-testid={`koli-sil-${ki}`} onClick={() => setKoliler(koliler.filter((_, j) => j !== ki))} className="text-muted-foreground hover:text-red-300"><Trash2 className="w-4 h-4" /></button></div>
          {kalemler.map((it) => (
            <div key={it.i} className="grid grid-cols-[1fr_100px] gap-2 items-center text-xs">
              <span className="truncate"><span className="font-mono text-muted-foreground mr-1">{it.kod}</span>{it.ad}</span>
              <Input data-testid={`koli-${ki}-miktar-${it.i}`} type="number" step="any" min="0" className="bg-white/5 h-8 text-right text-xs" value={k.kalemler[it.i] ?? ""}
                onChange={(e) => set(ki, (x) => ({ ...x, kalemler: { ...x.kalemler, [it.i]: e.target.value } }))} />
            </div>
          ))}
        </div>
      ))}
      {koliler.length > 0 && <div className="text-[11px] space-y-0.5" data-testid="koli-ozet">{kalemler.map((it) => {
        const d = dagitilan(it.i), m = Number(miktar[it.i] || 0);
        return <div key={it.i} className={Math.abs(d - m) > 1e-6 ? "text-amber-300" : "text-emerald-300"}>{it.kod}: kolilere {+d.toFixed(4)} / sevk {m} {it.birim}</div>;
      })}</div>}
    </div>
  );
};

export const koliGovde = (koliler) => koliler.map((k) => ({
  tip: k.tip || "Koli",
  kalemler: Object.entries(k.kalemler).map(([i, m]) => ({ kalem_idx: Number(i), miktar: Number(m) })).filter((x) => x.miktar > 0),
}));
